<template>
  <v-card>
    <v-app-bar
      v-if="showTopPanel"
      app 
      color="white"
      height="87"
      style="box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);"
    >
      <v-app-bar-nav-icon @click="drawer = true" class="ml-3 px-2 hidden-lg-and-up">
        <!--         
        <img
          class="ma-2"
          style="max-width:100%;max-height:70px;"
          :src="require('@/assets/logotipo-strategio.png')"
          alt="strategio-logotipo"
        >
        -->
        <v-icon style="font-size: x-large;">mdi-menu</v-icon>
      </v-app-bar-nav-icon>

      <v-col cols="3" style="padding-left:5%">
        <v-toolbar-title class="ml-2">
          <v-img
            width="205px"
            :src="require('@/assets/logo-strategio.png')"
            alt="strategio-logo">
          </v-img>
        </v-toolbar-title>
      </v-col>

      <v-col cols="5">
        <v-text-field
          id="filter-textfield"
          v-if="!['xs'].includes($vuetify.breakpoint.name)"
          single-line
          filled
          rounded
          v-model.lazy="searchProps.searchCriteria"
          @keyup.enter="searchItems()"
          class="hidden-xs-only "
          hide-details="auto"
          height="50"
        >
          <template v-slot:label>
            <div class="search-text-label">
              Buscar reporte
            </div>
          </template>
          <template v-slot:prepend-inner>
            <v-icon size="15.83px" class="search-text-prepend">ico-icons_search</v-icon>
          </template>
          <template v-slot:append>
            <v-fade-transition leave-absolute>
                <v-btn color="white" id="search-button" text icon @click="searchItems()"
              style="background-color:#2262C6;width:41px;height: 41px;margin-top: -10px;margin-right: -17px;" 
            >
              <v-icon>mdi-arrow-right</v-icon>
            </v-btn>
            </v-fade-transition>
          </template>
        </v-text-field>

      </v-col>
      
      <v-btn :disabled="false" text icon @click="toggleSearchBar" class="hidden-sm-and-up">
        <v-icon>search</v-icon>
      </v-btn>

      <v-avatar :tile="false" size="45px" style="margin-left: 136px; margin-right: 21px;" @click="goMyAccount()">
        <v-img :src="require('@/assets/icono-user.png')"></v-img>
      </v-avatar>

      <div class="hidden-xs-only" style="margin-right: 45.5px">
        <v-row >
          <span class="app-bar-text" style="color:#25235F; font-weight: bold;">{{userInfo.name}}</span>
        </v-row>
        <v-row>
          <span class="app-bar-text-subtitle">{{userInfo.company}}</span>
        </v-row>
      </div>
      
      <v-badge
        color="#23A2D9"
        :content="this.countFavorite"
        :value="this.countFavorite > 0"
        overlap
      >
        <v-btn 
          icon
          small
          size="28.8px"
          color="#25235F" id="favorite-button" @click="goFavorites()">
          <v-icon>ico-icon-star-2</v-icon>
        </v-btn>
      </v-badge>

      <!-- <v-btn 
        icon
        small
        class="ml-3" color="#25235F" id="email-button">
        <v-icon>mdi-email-outline</v-icon>
      </v-btn>

      <v-btn 
        icon
        small
        class="ml-3" color="#25235F" id="bell-button">
        <v-icon>mdi-bell-outline</v-icon>
      </v-btn> -->

    </v-app-bar>

    <v-navigation-drawer style="border-radius: 0px;" app :mini-variant.sync="mini" color="#2262C6" v-model="drawer" mini-variant-width="80" width="300">
      <v-list style="border-top: 0px lightgray solid; padding-top: 0px;">
        
        <v-list-item @click="mini = !mini" style="height:87px;">
          <v-list-item-icon style="position: absolute;left: 15px;top: 9px;">
            <v-btn icon>
              <v-icon 
                size="30"
                color="white">
                {{ mini ? 'ico-icon-eye-slashed-1' : 'close'}}
              </v-icon>
            </v-btn>
          </v-list-item-icon>

          <!-- <v-list-item-title 
          style="background: white;height: 100%;width: 202px;left: 101px;
            position: absolute;"></v-list-item-title> -->
        </v-list-item>
        <!-- <v-list-item style="height: 15px"></v-list-item> -->
        
        <!-- Retroceder
        <v-list-item @click="goBack()" 
        id="back-button"
        v-if="currentLocation === 'ShowReport'"
        class="btn-enabled"
        >
          <v-list-item-action style="margin-right: 5%;">
            <v-btn 
              icon
              dark
              large
              style="height:45px; width:45px"
            >
              <v-icon style="font-size: large;">arrow_back</v-icon>
            </v-btn>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title
              :style="{'color': '#FFFFFF'}"
            >Back</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        -->

        <!--GO HOME-->
        <v-list-item @click="goHome()" :class="['v-item']">
          <v-list-item-action style="margin-right: 5%;">
            <v-btn 
              icon
              dark
              large
              style="height:40px; width:40px"
              :class="{'selected-menu': currentLocation === 'MainPage'}"
            >
              <v-icon style="font-size: x-large;">ico-icon-home</v-icon>
            </v-btn>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title
              :style="{'color': '#FFFFFF'}"
            >Home</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider style="border-color:white;opacity: 10%;"></v-divider>

        <!-- Reportes -->
        <v-list-item @click="goReports()" :class="['v-item']">
          <v-list-item-action style="margin-right: 5%;">
            <v-btn
              icon
              dark
              large
              style="height:40px; width:40px"
              :class="{'selected-menu': currentLocation === 'Reports'}"
            >
              <v-icon style="font-size: x-large;">ico-icon-report</v-icon>
            </v-btn>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title
              :style="{'color':'#FFFFFF'}"
            >Reportes</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider style="border-color:white;opacity: 10%;"></v-divider>

        <!-- Cube -->
        <v-list-item @click="goDownloadCube()" :class="['v-item']">
          <v-list-item-action style="margin-right: 5%;">
            <v-btn
              icon
              dark
              large
              style="height:40px; width:40px"
              :class="{'selected-menu': currentLocation === 'DownloadCube'}"
            >
              <v-icon style="font-size: x-large;">mdi-cloud-download</v-icon>
            </v-btn>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title
              :style="{'color':'#FFFFFF'}"
            >Descargar Cubo</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider style="border-color:white;opacity: 10%;"></v-divider>
        <!--Favoritos-->
        <v-list-item @click="goFavorites()" :class="['v-item']">
          <v-list-item-action style="margin-right: 5%;">
            <v-btn
              icon
              dark
              large
              style="height:40px; width:40px"
              :class="{'selected-menu': currentLocation === 'Favorites'}"
            >
              <v-icon style="font-size: x-large;"
              >ico-icon-star</v-icon>
            </v-btn>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title 
              style="color:#FFFFFF"
            >Mis Favoritos</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider style="border-color:white;opacity: 10%;"></v-divider>

        <!--Perfil-->
        <v-list-item @click="goMyAccount()" :class="['v-item']">
          <v-list-item-action style="margin-right: 5%;">
            <v-btn
              icon
              dark
              large
              style="height:40px; width:40px"
              :class="{'selected-menu': currentLocation === 'UserAccount'}"
            >
              <v-icon style="font-size: x-large;"
              >ico-icon-user</v-icon>
            </v-btn>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title 
              style="color:#FFFFFF"
            >Mi Perfil</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider style="border-color:white;opacity: 10%;"></v-divider>

        <!--Pregunta a mis datos-->
        <v-list-item @click="goHelpdesk()" :class="['v-item']">
          <v-list-item-action style="margin-right: 5%;">
            <v-btn
              icon
              dark
              large
              style="height:40px; width:40px"
              :class="{'selected-menu': currentLocation === 'ShowHelpdesk'}"
            >
              <v-icon style="font-size: x-large;"
              >ico-icon-headphone</v-icon>
            </v-btn>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title 
              style="color:#FFFFFF"
            >Helpdesk</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider style="border-color:white;opacity: 10%;"></v-divider>

        <!--Administrar usuarios-->
        <v-list-item @click="goAdmin()" v-if="showAdmin || manageUserAccess" :class="['v-item']">
          <v-list-item-action style="margin-right: 5%;">
            <v-btn
              icon
              dark
              large
              style="height:40px; width:40px"
              :class="{'selected-menu': currentLocation === 'UserAdmin'}"
            >
              <v-icon style="font-size: x-large;"
              >ico-icontune</v-icon>
            </v-btn>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title
              :style="{'color': currentLocation === 'UserAdmin' || currentLocation === 'UserAdminByID' || currentLocation === 'UserAdminCreate' ? 'white' : 'white'}"
            >Administrar</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        
        <v-divider style="border-color:white;opacity: 10%;"></v-divider>

        <!--Autoservicio-->
        <v-list-item @click="goAutoservicio()" v-if="showAdmin || autoserviceAccess" :class="['v-item']">
          <v-list-item-action style="margin-right: 5%;">
            <v-btn
              icon
              dark
              large
              style="height:40px; width:40px"
              :class="{'selected-menu': currentLocation === 'Apps'}"
            >
              <v-icon style="font-size: x-large;"
              >ico-icon-config</v-icon>
            </v-btn>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title
              style="color:#FFFFFF"
            >Apps</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider style="border-color:white;opacity: 10%;"></v-divider>
        
        <!--Cerrar sesion-->
        <v-list-item @click="logOut()" :class="['v-item']">
          <v-list-item-action style="margin-right: 5%;">
            <v-btn
            icon
            dark
            large
            style="height:40px; width:40px"
          >
            <v-icon color="white" style="font-size:x-large;">ico-icon-close</v-icon>
            </v-btn>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title style="color:#FFFFFF">Cerrar sesion</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        
      </v-list>
    </v-navigation-drawer>
  
  </v-card>
</template>

<script>
/* eslint-disable */
import eventBus from "../../utils/eventBus";
import introBus from "../../utils/introBus";
import userStorage from "../../storage/userStorage";
import reportsStorage from "../../storage/reportsStorage";
import uris from "../../utils/uris"

export default {
  name: "strategio-app-bar",
  data() {
    const userInfo = userStorage.getUserInfo();
    if (Object.keys(userInfo).length === 0) {
      this.$router.push("login");
    }
    let showDrawer = !["xs", "sm", "md"].includes(
      this.$vuetify.breakpoint.name
    );
    return {
      userInfo,
      showMenu: userInfo.userType !== "DEMO",
      showSupervise: ["ADMIN", "SUPERVISOR"].indexOf(userInfo.userType) > -1,
      showAdmin: userInfo.userType === "ADMIN",
      autoserviceAccess: userInfo.autoserviceAccess === 1,
      manageUserAccess: userInfo.manageUserAccess === 1,
      drawer: showDrawer,
      acron: this.getAcron(userInfo.name),
      currentLocation: this.$route.name,
      tutorialDisabled: true,
      mini: true,
      countFavorite: 0,
      biCondition: false
    };
  },
  mounted() {
    eventBus.$off("enable-tutorial-button");
    eventBus.$on("enable-tutorial-button", () => {
      this.tutorialDisabled = false;
    });
  },
  methods: {
    startTutorial() {
      introBus.setIntroBus(introBus.getVueInstance().$intro());
      let intro = introBus.getIntroBus();
      // intro.onskip(() => {}) // Fixed intro.js bug

      intro.setOptions({
        disableInteraction: true,
        scrollToElement: true,
        skipLabel: "Salir",
        nextLabel: "Siguiente",
        prevLabel: "Previo",
        doneLabel: "Listo",
        tooltipClass: "strategio-introjs-customclass",
        steps: [
          {
            element: "#favorite-button",
            intro:
              "Este botón le llevará a la sección de reportes marcados como favoritos. Desde allí también se podrá desmarcar cualquier reporte"
          }
        ]
      });

      switch (this.currentLocation) {
        case "Login":
          break;
        case "MainPage":
          // emits to: /routes/main-page.vue
          eventBus.$emit("start-main-page-tutorial");
          break;
        case "SearchItems":
          break;
        case "ShowReport":
          break;
        case "Favorites":
          break;
        case "UserAccount":
        case "UserAdminByID":
        case "UserAdminCreate":
          // emits to: /components/users/user-form.vue
          eventBus.$emit("start-user-form-tutorial");
          break;
        case "UserAdmin":
          // emits to: /routes/user-admin.vue
          eventBus.$emit("start-user-admin-tutorial");
          break;
        case "SuperviseDashboard":
          // emits to: /routes/supervise-dashboard.vue
          eventBus.$emit("start-supervise-dashboard-tutorial");
          break;
        default:
          break;
      }
    },
    toggleSearchBar() {
      // emites to: routes/main-page.vue
      eventBus.$emit("toggle-search-bar");
    },
    isProfileImage(url) {
      if (url) {
        return url.trim() !== "";
      }
      return false;
    },
    getAcron(text) {
      let acron = "";
      if (text.length > 1) {
        const matches = text.match(/\b(\w)/g);
        acron =
          matches.length > 1 ? matches[0] + matches[1] : text[0] + text[1];
      }
      return acron.toUpperCase();
    },
    goBack() {
      // Retrocendiendo una pagina
      this.$router.go(-1);
      
      // Ocultando el boton de retroceso
      this.biCondition = false;
    },
    goHome() {
      this.$router.push("/0");
    },
    goFavorites() {
      this.$router.push("/user/favorites");
    },
    goReports() {
      this.$router.push("/reports/info");
    },
    goDownloadCube() {
      this.$router.push("/download-cube/info");
    },
    goMyAccount() {
      this.$router.push("/user/account");
    },
    goAdmin() {
      this.$router.push("/user/admin");
    },
    goSupervise() {
      this.$router.push("/supervise/dashboard");
    },
    goHelpdesk() {
      if (uris.URL_HELPDESK.length === 0) return
      window.open(uris.URL_HELPDESK, '_blank').focus()
      // this.$router.push({name: 'ShowHelpdesk'})
    },
    goAutoservicio() {
      this.$router.push("/apps/info");
    },
    logOut() {
      this.$router.push("/login");
    }
  },
  props: {
    searchCriteria: {
      type: String,
      default() {
        return "halp";
      }
    },
    searchProps: {
      type: Object,
      default() {
        return { searchCriteria: "" };
      }
    },
    searchItems: {
      type: Function,
      default() {
        return () => {};
      }
    },
    showTopPanel: {
      type: Boolean,
      default() {
        return true
      }
    }
  },
  mounted () {
    reportsStorage.getCountFavorite({
      onSuccess: (data) => {
        this.countFavorite = data
      }
    })
    // this.changeStatus(biCondition);
    // document.getElementById('back-button');
  },
};
</script>
<style>
.v-item {
  height: 9vh;
}

.search-text-label {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  opacity: 0.27;
  color: #000000;
}

.search-text-prepend {
  margin-right: 15.5px;
  padding: 6px 0px;
  opacity: 0.27;
  -webkit-text-stroke: 0.3px #000 
}

.strategio-cargo {
  text-align: center;
}
.strategio-nombre {
  font-size: 24px;
  font-weight: 300;
  text-align: center;
}
.strategio-avatar {
  text-align: center;
  margin-left: 84px;
  margin-top: 40px;
  margin-bottom: 32px;
}
.strategio-acron {
  font-weight: 300;
  font-size: 20px;
}
.introjs-helperLayer {
  opacity: 0.7;
  background-color: gray !important;
}

.strategio-introjs-customclass {
  /* font-size: 20px; */
  font-family: "Roboto", "Material Icons", sans-serif;
}

.v-toolbar__content{
  padding: 0%;
  height: 87px !important;
}

.app-bar-text {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 27px;
}

.app-bar-text-subtitle {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #7A7567;
  opacity: 0.5;
}

.selected-menu {
  background: white;
}

.selected-menu i {
  color: #2262C6 !important;
}

.btn-disabled {
  height:0px;
  visibility: hidden;
}

.btn-enabled {
  height:80px;
  visibility: visible;
}
</style>



// WEBPACK FOOTER //
// src/components/header-bar/strategio-app-bar.vue